// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import "./elementStyle/index.css"
import "./assets/styles/elementUi.css"
// import 'element-ui/lib/theme-chalk/index.css'
import commonPlugin from './plugins/common'
import store from './store/index'
import Http from './service/request'
import jsoneditor from 'jsoneditor'
import md5 from 'js-md5';
import { Base64 } from 'js-base64'

import './assets/nprogress/nprogress.css'
import NProgress from './assets/nprogress/nprogress.js'


Vue.config.productionTip = false

/** 原型链挂载 */
Vue.prototype.$Http = Http;
Vue.prototype.$jsoneditor = jsoneditor;
Vue.prototype.$nprogress = NProgress; // 也可以直接访问 NProgress
Vue.prototype.$md5 = md5;
Vue.prototype.$version = process.env.NODE_ENV //  process.env是一个全局变量，能够判断当前环境

// generateToken();

/** 注册插件 */
const PLUGINS = [
    [ElementUI, { size: 'small' }], commonPlugin
];

PLUGINS.forEach(item => { // 动态注册插件
    Array.isArray(item) ? Vue.use(...item) : Vue.use(item)
})
new Vue({
    el: '#app',
    router: router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js